import React from 'react'
import Link from 'gatsby-link'
import styles from './layout.module.scss'
import Layout from '../layouts/index.js'
import LightBox from '../components/lightbox/lightbox.js'

import Hero from '../images/index/hero.jpg'

import MakeUp from '../images/index/IMG_6116.jpg'
import Palin from '../images/index/008676.jpg'
import Warm from '../images/index/006091-2.jpg'
import Book from '../images/index/emperor.jpg'

import Signature from '../images/signature.svg'

const IndexPage = () => (
  <Layout>
    <section className={styles.index}>
      <div className={styles.hero}>
        <figure>
          <img src={Hero} alt="" />
        </figure>
      </div>
      <div className={styles.photos}>
        <LightBox src={MakeUp} alt="" />
        <LightBox src={Palin} alt="" />
        <LightBox src={Warm} alt="" />
        <LightBox src={Book} alt="" />
      </div>
      <article className={styles.text}>
        <p>Welcome</p>
        <p>
          Many thanks for visiting my website. Here you can discover how I
          became involved with{' '}
          <Link to="/about/">wildlife TV/photography and adventure travel</Link>
          , find out about my{' '}
          <Link to="/trips-events/">upcoming trips and events</Link> and see a
          selection of{' '}
          <Link to="/gallery/">
            my images, many taken in destinations where you can join me
          </Link>
          .
        </p>
        <p>
          You will also <Link to="/shop/">find a shop</Link> where you can order
          my books, including the newest:{' '}
          <Link to="/shop/">
            <strong>Emperor: The Perfect Penguin</strong>
          </Link>{' '}
          featuring more than 200 shots of my favourite bird and its icy home,
          and with a foreword by Michael Palin.
        </p>
        <p>
          See also <Link to="/favourite-things/">my favourite things</Link> for
          insights into some of the places, suppliers, people and organisations
          I like the best.
        </p>
        <p>
          I hope you enjoy your visit and that you’ll feel free to get in touch
          if you’d like to know more. You are also most welcome to connect with
          me on{' '}
          <a
            className={styles.twitter}
            href="https://twitter.com/suefloodphotos"
            target="_blank"
            rel="noreferrer"
          >
            Twitter
          </a>
          ,{' '}
          <a
            className={styles.instagram}
            href="https://www.instagram.com/suefloodphotography/"
            target="_blank"
            rel="noreferrer"
          >
            Instagram
          </a>{' '}
          &{' '}
          <a
            className={styles.facebook}
            href="https://www.facebook.com/suefloodphotos/"
            target="_blank"
            rel="noreferrer"
          >
            Facebook
          </a>
          .
        </p>
        <p>
          <img className={styles.signature} alt="" src={Signature} />
        </p>
        <p>Sue Flood</p>
      </article>
    </section>
  </Layout>
)

export default IndexPage
